import {
  ADD_TO_WISHLIST,
  DECISION_CLICK_TRACKER,
  DECISION_IMP_TRACKER,
  HOME,
  MOLOCO_PAGE_VIEW,
  SEARCH,
} from '@constants/moloco/molocoSpec';
import { putTagManagerWithDataLayer } from '@utils/tagManagerUtil';
import { uuidv4 } from '@wconcept/wconcept-common/utils/commonUtils';
import { getCookieWckDisplayMktSID } from '@wconcept/wconcept-common/utils/cookie';
import { getMolocoCustNo } from '@wconcept/wconcept-common/utils/domainUtil';
import useGlobalState from './useGlobalState';

function useMolocoLogger() {
  const { appInfo, assistData } = useGlobalState();

  const sendMolocoAddToWish = async ({
    itemCd,
    amount,
    pageId,
  }: {
    itemCd: string;
    amount: number;
    pageId: string;
  }) => {
    const dataLayer = ADD_TO_WISHLIST;
    dataLayer.molocoData.id = uuidv4();
    const userId = await getMolocoCustNo(false, assistData.user.userNo);
    dataLayer.molocoData.session_id = encodeURIComponent(
      await getCookieWckDisplayMktSID()
    );
    dataLayer.molocoData.user_id = userId || '';
    dataLayer.molocoData.channel_type = appInfo.isNativeAppBoth
      ? 'APP'
      : 'SITE';
    dataLayer.molocoData.timestamp = new Date().getTime();
    dataLayer.molocoData.items[0].id = itemCd || '';
    dataLayer.molocoData.items[0].price.amount = amount || 0;
    dataLayer.molocoData.items[0].quantity = 1;
    dataLayer.molocoData.page_id = pageId;
    if (!dataLayer.molocoData.user_id) {
      delete dataLayer.molocoData.user_id;
    }
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  const sendMolocoHome = async (pageId: string) => {
    const dataLayer = HOME;
    dataLayer.molocoData.id = uuidv4();
    const userId = await getMolocoCustNo(false, assistData.user.userNo);
    dataLayer.molocoData.session_id = encodeURIComponent(
      await getCookieWckDisplayMktSID()
    );
    dataLayer.molocoData.user_id = userId || '';
    dataLayer.molocoData.channel_type = appInfo.isNativeAppBoth
      ? 'APP'
      : 'SITE';
    dataLayer.molocoData.timestamp = new Date().getTime();
    dataLayer.molocoData.page_id = pageId;
    if (!dataLayer.molocoData.user_id) {
      delete dataLayer.molocoData.user_id;
    }
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  const sendMolocoSearch = async (keyword: string, pageId: string) => {
    const dataLayer = SEARCH;
    dataLayer.molocoData.id = uuidv4();
    const userId = await getMolocoCustNo(false, assistData.user.userNo);
    dataLayer.molocoData.session_id = encodeURIComponent(
      await getCookieWckDisplayMktSID()
    );
    dataLayer.molocoData.user_id = userId || '';
    dataLayer.molocoData.channel_type = appInfo.isNativeAppBoth
      ? 'APP'
      : 'SITE';
    dataLayer.molocoData.timestamp = new Date().getTime();
    dataLayer.molocoData.page_id = pageId;
    dataLayer.molocoData.search_query = keyword;
    if (!dataLayer.molocoData.user_id) {
      delete dataLayer.molocoData.user_id;
    }
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  const sendMolocoPageView = async ({
    pageId,
    type,
  }: {
    pageId: string;
    type: 'HOME' | 'PAGE_VIEW';
  }) => {
    const dataLayer = MOLOCO_PAGE_VIEW;
    dataLayer.molocoData.event_type = type;
    dataLayer.molocoData.id = uuidv4();
    const userId = await getMolocoCustNo(false, assistData.user.userNo);
    dataLayer.molocoData.session_id = encodeURIComponent(
      await getCookieWckDisplayMktSID()
    );
    dataLayer.molocoData.user_id = userId || '';
    dataLayer.molocoData.channel_type = appInfo.isNativeAppBoth
      ? 'APP'
      : 'SITE';
    dataLayer.molocoData.timestamp = new Date().getTime();
    dataLayer.molocoData.page_id = pageId;
    if (!dataLayer.molocoData.user_id) {
      delete dataLayer.molocoData.user_id;
    }
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  const sendMolocoDecisionClickTracker = async (url: string) => {
    const dataLayer = DECISION_CLICK_TRACKER;
    dataLayer.molocoData = url;
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  const sendMolocoImpTracker = async (url: string[]) => {
    const dataLayer = DECISION_IMP_TRACKER;
    dataLayer.molocoData = url;
    // 앱웹 구분 없이 gtm 트리거 호출
    putTagManagerWithDataLayer(appInfo.isNativeAppBoth, dataLayer);
  };

  return {
    sendMolocoAddToWish,
    sendMolocoHome,
    sendMolocoSearch,
    sendMolocoDecisionClickTracker,
    sendMolocoPageView,
    sendMolocoImpTracker,
  };
}

export default useMolocoLogger;
